import QRCode from 'qrcode';

export const generateProductQR = async (canvasRef: any, name: string, listingNumber: string) => {
    console.log('generateProductQR', name, listingNumber);
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    const width = 400; // Ширина изображения
    const height = 400; // Высота изображения

    ctx.clearRect(0, 0, width, height);

    canvas.width = width;
    canvas.height = height;

    ctx.fillStyle = '#fff';
    ctx.fillRect(0, 0, width, height);

    ctx.fillStyle = '#000';
    ctx.font = '20px Arial';
    ctx.textAlign = 'center';
    ctx.fillText(name, width / 2, 50);
    ctx.fillText(`№: ${listingNumber}`, width / 2, 80);

    const qrCanvas = document.createElement('canvas');
    await QRCode.toCanvas(qrCanvas, listingNumber, {width: 280, margin: 0});
    ctx.drawImage(qrCanvas, width / 2 - 140, 100, 280, 280);

    const image = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = image;
    link.download = `${listingNumber}_product_qr.png`;
    link.click();
};
